/**
 * Filter Repository
 * 
 * Handles all filter-related edge function calls.
 * Follows the Repository pattern for clean separation of concerns.
 */

import EdgeFunctionRepository from './EdgeFunctionRepository';

class FilterRepository {
  /**
   * Get all unique state names for filtering
   * @returns {Promise<string[]>} Sorted array of unique state names
   */
  async getFilterStates() {
    try {
      const data = await EdgeFunctionRepository.get('get-filter-states');
      return data || [];
    } catch (error) {
      console.error('[FilterRepository] Failed to fetch filter states:', error);
      return [];
    }
  }

  /**
   * Get all unique organisation (brand) names for filtering
   * @returns {Promise<string[]>} Sorted array of unique brand names
   */
  async getFilterOrganisations() {
    try {
      const data = await EdgeFunctionRepository.get('get-filter-organisations');
      return data || [];
    } catch (error) {
      console.error('[FilterRepository] Failed to fetch filter organisations:', error);
      return [];
    }
  }

  /**
   * Get facility IDs matching the given filter criteria
   * @param {string[]} states - Selected state names
   * @param {string[]} organisations - Selected organisation (brand) names
   * @returns {Promise<string[]>} Array of matching facility IDs
   */
  async filterFacilities(states = [], organisations = []) {
    try {
      const params = {};
      if (states.length > 0) {
        params.states = states.join(',');
      }
      if (organisations.length > 0) {
        params.organisations = organisations.join(',');
      }

      const data = await EdgeFunctionRepository.get('filter-facilities', params);
      return data || [];
    } catch (error) {
      console.error('[FilterRepository] Failed to filter facilities:', error);
      return [];
    }
  }
}

// Export singleton instance
const filterRepository = new FilterRepository();
export default filterRepository;
